module.exports = __webpack_public_path__ + "assets/img/ic-export.6e454fdc.svg";